/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_SugarInputs */

const en_nutrient_sugar = /** @type {(inputs: Nutrient_SugarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugar`)
};

const de_nutrient_sugar = /** @type {(inputs: Nutrient_SugarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zucker`)
};

/**
* | output |
* | --- |
* | "Sugar" |
*
* @param {Nutrient_SugarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_sugar = /** @type {((inputs?: Nutrient_SugarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_SugarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_sugar(inputs)
	return en_nutrient_sugar(inputs)
});